import {
  Box,
  Container,
  HStack,
  Breadcrumb,
  BreadcrumbItem,
  Heading,
  ListItem,
  useDisclosure,
  Text,
  Button as CButton,
} from "@chakra-ui/react";

import { useMemo } from "react";

import { ChevronRightIcon } from "@chakra-ui/icons";

import { useParams } from "react-router-dom";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import toUpper from "lodash/toUpper";
import toLower from "lodash/toLower";
import { format, parseISO } from "date-fns";
import toPrecision from "util/toPrecision";

import CryptoDetails from "./CryptoDetails";
import FiatDetails from "./FiatDetails";

import constants from "config/constant";

export const TransactionItem = ({
  type,
  currency,
  description,
  createdAt,
  value,
  transactionId,
}) => {
  const { /*isOpen, onClose,*/ onOpen } = useDisclosure();

  // console.log("transaction id", transactionId);

  const getColor = (type) => {
    const map = {
      credit: "#00BA88",
      debit: "#ED2E7E",
    };

    return map[toLower(type) ?? "credit"];
  };

  const getType = (type) => {
    const map = {
      [toLower(type)]: toLower(type).includes("debit") ? "debit" : "credit",
      contract_credit: "credit",
      contract_debit: "debit",
    };

    return map[toLower(type)];
  };

  console.log("TYPE", getType(type));

  return (
    <>
      <ListItem
        w="100%"
        as={CButton}
        minH="fit-content"
        bg="transparent"
        p="32px 0"
        borderRadius="2px"
        borderBottom={
          // i !== items.length - 1 ? "1px solid #D9DBE9" : "none"
          "1px solid #EAEAEA"
        }
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        _focus={{ bg: "transparent", shadow: "0 0 0 3px var(--focusColor)" }}
        onClick={onOpen}
      >
        <HStack justifyContent="space-between" w="100%" px="4px">
          <HStack alignItems="flex-start">
            <Box
              mt="6px !important"
              borderRadius="50%"
              boxSize="10px"
              bg={getColor(getType(type))}
            />
            <Box>
              <Text
                textAlign="left"
                fontSize="sm"
                fontWeight="500"
                color="#595B67"
                // w="40%"
                // whiteSpace="nowrap"
                // textOverflow="ellipsis"
                overflow="hidden"
                m="0 !important"
              >
                {description}
              </Text>
              <Text textAlign="left" fontSize="12px" mt="2px">
                {format(parseISO(createdAt), "eee, dd MMM yyyy, HH:mm")}
              </Text>
            </Box>
          </HStack>

          <Text>
            {getType(type) === "debit" ? "-" : ""}
            {/* {formatter(currency).format(value?.$numberDecimal)} */}
            {toPrecision(value?.$numberDecimal, currency)}
          </Text>
        </HStack>
      </ListItem>

      {/* <TransactionDetailModal
          type={type}
          description={description}
          amount={value?.$numberDecimal}
          createdAt={createdAt}
          currency={currency}
          txId={transactionId}
          title={`${description} Details`}
          onClose={onClose}
          isOpen={isOpen}
        /> */}
    </>
  );
};

const WalletDetails = (props) => {
  const currentPage = "Wallet";

  const { coin } = useParams();

  // const { getCoin, isLoading } = useWallet();

  const isFiat = useMemo(() => constants.fiats.includes(toLower(coin)), [coin]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="wallet">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box>
              <Heading fontSize="3xl">Wallet</Heading>
              <Breadcrumb
                // my="20px"
                // mx="20px"
                separator={<ChevronRightIcon color="gray.500" />}
              >
                <BreadcrumbItem>
                  <BreadcrumbLink
                    // to={`/dashboard/wallet?tab=${isFiat ? "fiat" : "crypto"}`}
                    to={`/dashboard/wallet`}
                  >
                    Wallet
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink
                    isCurrentPage
                    to={`/dashboard/wallet/${coin}`}
                  >
                    {toUpper(coin)}
                  </BreadcrumbLink>

                  {/* {(isUpdatingRate ||
                isCountriesLoading ||
                isWalletsLoading ||
                isPlansLoading) && (
                <CircularProgress
                  ml="16px"
                  isIndeterminate
                  color="green.500"
                  size="16px"
                />
              )} */}
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            {isFiat ? (
              <FiatDetails coin={coin} userData={props?.userData} />
            ) : (
              <CryptoDetails coin={coin} />
            )}
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default WalletDetails;
